import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { UserBehaviorService } from "../../services/user-behavior/user-behavior.service";
import { MatSort, MatTableDataSource } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-user-detail",
  templateUrl: "./user-detail.component.html",
  styleUrls: ["./user-detail.component.scss"],
})
export class UserDetailComponent implements OnInit {
  loading = true;
  userId;
  user: any = {};
  referringDate = new Date(1900, 0, 0);
  dataSource = new MatTableDataSource([]);
  dataSourceParticipating = new MatTableDataSource([]);

  constructor(
    private userBehaviorService: UserBehaviorService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  displayedColumns = [
    "name",
    "epicCount",
    "itemCount",
    "lastItemOperation",
    "sprintCount",
    "lastSprintOperation",
    "annotationCount",
    "lastAnnotationOperation",
    "retroCount",
    "lastRetroOperation",
    "coachCount",
    "jiraSync",
  ];
  displayedColumnsParticipating = [
    "name",
    "owner",
    "epicCount",
    "itemCount",
    "lastItemOperation",
    "sprintCount",
    "lastSprintOperation",
    "annotationCount",
    "lastAnnotationOperation",
    "retroCount",
    "lastRetroOperation",
    "coachCount",
    "jiraSync",
  ];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatSort) sortParticipating: MatSort;

  async ngOnInit() {
    this.route.params.subscribe((params: { id: string }) => {
      this.userId = params.id;
      this.setup();
    });
  }

  async setup() {
    this.loading = true;

    await this.userBehaviorService.getUser(this.userId).then((response) => {
      this.user = response.UserResponse.users[0];
      // console.log(this.user);
      if (response.UserResponse.users[0].projects.length > 0) {
        this.createDataSource(response.UserResponse.users[0].projects);
        this.dataSource.sort = this.sort;
        this.dataSourceParticipating.sort = this.sortParticipating;
      }
    });
    this.loading = false;
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }
  applyFilterParticipating(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSourceParticipating.filter = filterValue;
  }

  createDataSource(projects) {
    this.dataSource = new MatTableDataSource([]);
    this.dataSourceParticipating = new MatTableDataSource([]);
    let dataObjects = this.dataSource.data;
    let dataObjectsParticipating = this.dataSourceParticipating.data;
    projects.forEach((element) => {
      if (element.ownerId === this.userId) {
        dataObjects.push({
          name: element.name,
          epicCount: element.numOfThemes,
          itemCount: element.numOfFeatures,
          lastItemOperation: new Date(element.recentItem),
          sprintCount: element.numOfSprints,
          lastSprintOperation: new Date(element.recentSprint),
          annotationCount: element.numOfAnnotations,
          lastAnnotationOperation: new Date(element.recentAnnotation),
          retroCount: element.numOfRetrospectives,
          lastRetroOperation: new Date(element.recentRetrospective),
          coachCount: element.numOfParticipants,
          jiraSync: element.issueTrackerLink.issueTracker ? true : false,
        });
      } else {
        dataObjectsParticipating.push({
          name: element.name,
          owner: element.ownerId,
          epicCount: element.numOfThemes,
          itemCount: element.numOfFeatures,
          lastItemOperation: new Date(element.recentItem),
          sprintCount: element.numOfSprints,
          lastSprintOperation: new Date(element.recentSprint),
          annotationCount: element.numOfAnnotations,
          lastAnnotationOperation: new Date(element.recentAnnotation),
          retroCount: element.numOfRetrospectives,
          lastRetroOperation: new Date(element.recentRetrospective),
          coachCount: element.numOfParticipants,
          jiraSync: element.issueTrackerLink.issueTracker ? true : false,
        });
      }
    });
    this.dataSource.data = dataObjects;
    this.dataSourceParticipating.data = dataObjectsParticipating;
  }

  ownerClicked(ownerId) {
    this.router.navigate(["/user-detail/", ownerId]);
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/user-detail/user-detail.component.ts